/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDataSourceResultDtoOfPresentDeviceUserInfoDto } from '../../models/platform-api-result-of-data-source-result-dto-of-present-device-user-info-dto';
import { PlatformGetPresentDeviceUsers } from '../../models/platform-get-present-device-users';

export interface PostUserpresenceQueryCustomdatasource$Params {
      body: PlatformGetPresentDeviceUsers
}

export function postUserpresenceQueryCustomdatasource(http: HttpClient, rootUrl: string, params: PostUserpresenceQueryCustomdatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfPresentDeviceUserInfoDto>> {
  const rb = new RequestBuilder(rootUrl, postUserpresenceQueryCustomdatasource.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfPresentDeviceUserInfoDto>;
    })
  );
}

postUserpresenceQueryCustomdatasource.PATH = '/api/userpresence/query/customdatasource';
